import Immutable from 'seamless-immutable';
import { FormHelper, i18n } from 'invision-core';
import CustomerCareLocaleKeys from '../../../../locales/keys';
import { CurrentHouseholdSelector, CurrentHouseholdMemberSelector, EditHouseholdDataSelector, HouseholdErrorSelector, IsCreatingHouseholdSelector, IsUpdatingHouseholdSelector, SelectedHouseholdMemberIdSelector, SelectedHouseholdMemberSelector } from '../../../../reducers/selectors/customer.household.selectors';
import { createHousehold, setEditHouseholdData, updateHousehold } from '../../../../reducers/actions/customer.household.actions';
import { CurrentCustomerSelector } from '../../../../reducers/selectors/customer.selectors';
function EditHouseholdPopupController($ngRedux, $timeout) {
  var _this = this;
  var disconnectRedux;
  var popupApi = null;
  var createSuccessMessage = i18n.translate(CustomerCareLocaleKeys.HOUSEHOLD.CREATE_HOUSEHOLD_SUCCESS);
  var updateSuccessMessage = i18n.translate(CustomerCareLocaleKeys.HOUSEHOLD.UPDATE_HOUSEHOLD_SUCCESS);
  var mapStateToTarget = function mapStateToTarget(store) {
    return {
      currentCustomer: CurrentCustomerSelector(store),
      currentHousehold: CurrentHouseholdSelector(store),
      currentMember: CurrentHouseholdMemberSelector(store),
      editHouseholdData: EditHouseholdDataSelector(store),
      isCreatingHousehold: IsCreatingHouseholdSelector(store),
      isUpdatingHousehold: IsUpdatingHouseholdSelector(store),
      lastAttemptError: HouseholdErrorSelector(store),
      selectedMember: SelectedHouseholdMemberSelector(store),
      selectedMemberId: SelectedHouseholdMemberIdSelector(store)
    };
  };
  var controllerActions = {
    createHousehold: createHousehold,
    setEditHouseholdData: setEditHouseholdData,
    updateHousehold: updateHousehold
  };
  this.$onInit = function () {
    _this.showForm = false;
    disconnectRedux = $ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
      _this.state = state;
      _this.actions = actions;
    });
    _this.resetForm();
    _this.customerCareKeys = CustomerCareLocaleKeys;
    _this.errorLookup = _this.getErrorLookupObject();

    // hook the popupApi
    var onRegisterApi = _this.config.onRegisterApi;
    _this.config.onRegisterApi = function (_ref) {
      var api = _ref.api;
      popupApi = Object.assign({}, api, {
        open: function open() {
          _this.resetForm();
          if (_this.household.Id) {
            _this.popupTitle = i18n.translate(_this.customerCareKeys.HOUSEHOLD.EDIT_HOUSEHOLD);
          } else {
            _this.popupTitle = i18n.translate(_this.customerCareKeys.HOUSEHOLD.NEW_HOUSEHOLD);
            _this.household.Name = _this.getDefaultHouseholdName();
          }
          _this.showForm = true;
          // NOTE: must wait for the ng-if bound to showForm to operate, for the popup centering logic
          $timeout(function () {
            api.open();
          });
        }
      });
      onRegisterApi && onRegisterApi({
        api: popupApi
      });
    };
  };
  this.getErrorLookupObject = function () {
    return {
      householdName: {
        required: i18n.translate(_this.customerCareKeys.HOUSEHOLD.ERRORS.HOUSEHOLD_NAME_REQUIRED),
        maxlength: i18n.translate(_this.customerCareKeys.HOUSEHOLD.ERRORS.HOUSEHOLD_NAME_100_CHAR)
      }
    };
  };
  this.checkForErrors = function (ngFormError) {
    var errorModelList = FormHelper.formHasErrors(ngFormError, _this.errorLookup);
    _this.formErrors = errorModelList;
    return errorModelList.length > 0;
  };
  this.handleSubmitForm = function (editHouseholdForm) {
    if (!_this.checkForErrors(editHouseholdForm.$error)) {
      if (_this.isUpdating()) {
        _this.actions.updateHousehold(_this.customerId, _this.household).then(_this.successCallback(updateSuccessMessage), _this.errorCallback());
      } else {
        _this.actions.createHousehold(_this.customerId, _this.household).then(_this.successCallback(createSuccessMessage), _this.errorCallback());
      }
    }
  };
  this.successCallback = function (message) {
    return function () {
      _this.closePopup();
      var onHouseholdEdited = _this.onHouseholdEdited();
      onHouseholdEdited && onHouseholdEdited(message, _this.state.selectedMemberId || _this.state.currentCustomer.Id);
    };
  };
  this.errorCallback = function () {
    return function () {
      _this.formErrors = [_this.state.lastAttemptError.message];
    };
  };
  this.closePopup = function () {
    if (!_this.state.isCreatingHousehold) {
      popupApi.close();
      _this.showForm = false;
    }
  };
  this.resetForm = function () {
    _this.setEditData(_this.state.currentHousehold || {});
    _this.household = Immutable.asMutable(_this.state.editHouseholdData, {
      deep: true
    });
    _this.formErrors = [];
  };
  this.getDefaultHouseholdName = function () {
    var substitutions = {
      lastName: _this.state.currentCustomer.LastName
    };
    return i18n.translate(_this.customerCareKeys.HOUSEHOLD.DEFAULT_HOUSEHOLD_NAME, substitutions);
  };
  this.handleFormChange = function () {
    _this.actions.setEditHouseholdData(_this.household);
  };
  this.isUpdating = function () {
    return _this.household.Id;
  };
  this.setEditData = function () {
    var household = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _this.actions.setEditHouseholdData(household);
  };
  this.$onDestroy = function () {
    disconnectRedux();
  };
}
export default {
  template: require('./edit.household.popup.html'),
  bindings: {
    customerId: '<',
    config: '<',
    onHouseholdEdited: '&'
  },
  controllerAs: 'EditHouseholdPopup',
  controller: EditHouseholdPopupController
};